import { MultiAppAuthenticationInfosAction, MultiAppAuthenticationInfosActionKeys } from './actions';
import { Server, AuthMethod } from './constants';
import { Api } from '../../typings/api';
import LocalStorageManager from '../../utils/localStorage/manager';

export enum AspConnexionStatus {
	NOT_AUTHENTICATE = 'notAuthenticate',
	PENDING = 'pending',
	SUCCESS = 'success',
	AUTH_ERROR = 'authError',
	NO_APP_ERROR = 'noMultiAppAuthenticationError',
	NO_COMPANY_ERROR = 'noCompany'
}

export interface MultiAppAuthenticationCredentials {
	login?: string;
	password?: string;
	token?: string;
	company?: string;
	method?: AuthMethod;
}

const getInitialState = () => {
	return {
		server: LocalStorageManager.getMultiAppServer() || undefined,
		aspConnexionStatus: AspConnexionStatus.NOT_AUTHENTICATE,
		accessibleApps: [],
		orgAuthMethods: [],
		credentials: LocalStorageManager.getMultiAppCredentials() || undefined
	} as MultiAppAuthenticationInfosState;
};

export const initialCredentials = {
	login: undefined,
	password: undefined,
	token: undefined,
	company: undefined,
	method: undefined
};

export interface MultiAppAuthenticationInfosState {
	server?: Server;
	aspConnexionStatus: AspConnexionStatus;
	credentials?: MultiAppAuthenticationCredentials;
	clientId?: number;
	accessibleApps: Api.AspDriveResourceItem[];
	orgAuthMethods: AuthMethod[];
}

export function multiAppAuthenticationInfos(
	state: MultiAppAuthenticationInfosState = getInitialState(),
	action: MultiAppAuthenticationInfosAction
): MultiAppAuthenticationInfosState {
	switch (action.type) {
		case MultiAppAuthenticationInfosActionKeys.RESET_STATUS:
			return { ...state, aspConnexionStatus: AspConnexionStatus.NOT_AUTHENTICATE };
		case MultiAppAuthenticationInfosActionKeys.LOGIN_SUCCESS:
			return { ...state, aspConnexionStatus: AspConnexionStatus.SUCCESS };
		case MultiAppAuthenticationInfosActionKeys.LOGIN_ERROR:
			return { ...state, aspConnexionStatus: action.status };
		case MultiAppAuthenticationInfosActionKeys.COMPANY_ERROR:
			return { ...state, aspConnexionStatus: AspConnexionStatus.NO_COMPANY_ERROR };
		case MultiAppAuthenticationInfosActionKeys.LOGOUT:
			return getInitialState();
		case MultiAppAuthenticationInfosActionKeys.UPDATE_CLIENT:
			return { ...state, clientId: action.clientId };
		case MultiAppAuthenticationInfosActionKeys.UPDATE_ACCESSIBLE_APPS:
			return { ...state, accessibleApps: action.accessibleApps };
		case MultiAppAuthenticationInfosActionKeys.UPDATE_AUTH_METHODS:
			return { ...state, orgAuthMethods: action.orgAuthMethods };
		case MultiAppAuthenticationInfosActionKeys.UPDATE_CREDENTIALS:
			return { ...state, credentials: action.credentials };
		case MultiAppAuthenticationInfosActionKeys.UPDATE_SERVER:
			return { ...state, server: action.server };
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MultiAppAuthentication/reducer.ts